/**
 * Способи входу (прототип v4 GSET_DEFAULT.signin) і ключі налаштування платформи signIn на сервері: Microsoft — entra, Google — google,
 * пароль — password, ID громадянина — idgovua; двофакторна автентифікація адміністраторів — mfaAdmins; сеанс — session. Типові значення —
 * доки сервер не відповів.
 */
export const signInDefaults = {
  staff: [['microsoft', 'entra'], ['google', 'google'], ['password', 'password']] as Array<[string, string]>,
  citizens: [['citizenId', 'idgovua']] as Array<[string, string]>,
  defaults: { entra: true, google: true, password: true, idgovua: true, mfaAdmins: false, session: '8h' } as Record<string, boolean | string>,
  sessions: ['1h', '8h', '24h', '7d'],
};
